var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTextColor(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 24,
    viewBox: "0 0 25 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.5 20C3.5 19.4477 3.94772 19 4.5 19H20.5C21.0523 19 21.5 19.4477 21.5 20C21.5 20.5523 21.0523 21 20.5 21H4.5C3.94772 21 3.5 20.5523 3.5 20Z",
    fill: "#52525B"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M15.996 14H9.004L7.65544 17.3714C7.50358 17.7511 7.13588 18 6.72699 18C6.01954 18 5.5358 17.2855 5.79854 16.6287L11.2486 3.62861C11.4004 3.24895 11.7681 3 12.177 3H12.823C13.2319 3 13.5996 3.24895 13.7514 3.62861L19.2015 16.6287C19.4642 17.2855 18.9805 18 18.273 18C17.8641 18 17.4964 17.7511 17.3446 17.3714L15.996 14ZM15.196 12L12.5 5.885L9.804 12H15.196Z",
    fill: "#52525B"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTextColor);
export default __webpack_public_path__ + "static/media/TextColor.97969246c3493a9d66086dd20a6af390.svg";
export { ForwardRef as ReactComponent };